import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=fa21d71a"
import script from "./CompanyDetails.vue?vue&type=script&lang=js"
export * from "./CompanyDetails.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetails.vue?vue&type=style&index=0&id=fa21d71a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports